<div class="filter-container">
  <app-button [button]="showFiltersButton"> </app-button>
</div>

<ng-container *ngIf="noBookmarks && !loading; else bookmarkList">
  <div class="no-appoint-message">
    <div>No Bookmarks Found!</div>
  </div>
</ng-container>

<ng-template #bookmarkList>
  <app-card [items]="cards"></app-card>
</ng-template>

<!--Shimmer-->
<div class="shimmer-container">
  <ng-container *ngIf="loading">
    <div class="shimmer-container">
      <app-shimmer
        [type]="shimmerTypeLGCard"
        *ngFor="let item of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
      ></app-shimmer>
    </div>
  </ng-container>
</div>

<!--Filters-->
<app-filter [items]="filterItems" [showClearAll]="false"> </app-filter>
